exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#bigImage[data-v-7d4ee226] {\n  width: 100%;\n}\n", ""]);

// exports
